import React, { Fragment, useState, useEffect, useRef } from "react";
import {
  faTimes,
  faSave,
  faTrash,
  faCheck } from
"@fortawesome/free-solid-svg-icons";
import GetAdminService from "../../../services/admin/GetAdminService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomLoader from "../../customLoader/CustomLoader";
import swal from "sweetalert";
import { Modal, ModalBody } from "reactstrap";
import "../AdminPages.css";
import "../Student/Student.css";

const MessageModal = ({ isOpen, setIsOpen, data }) => {
  return (
    <Fragment>
      <Modal isOpen={isOpen} centered={true}>
        <ModalBody>
          <div style={{ textAlign: "center" }}>
            <p>{data.message}</p>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <button
                onClick={data.function1}
                style={{
                  backgroundColor: "#009900",
                  color: "white",
                  padding: "5px",
                  border: "none",
                  outline: "none",
                  marginRight: "20px",
                  borderRadius: "5px"
                }}>
                
                <FontAwesomeIcon
                  style={{ margin: "0 5px" }}
                  color="white"
                  icon={faCheck} />
                
                Ok
              </button>
              <button
                onClick={() => setIsOpen(false)}
                style={{
                  backgroundColor: "#efefef",
                  color: "black",
                  padding: "5px",
                  border: "none",
                  outline: "none",
                  marginLeft: "20px",
                  borderRadius: "5px"
                }}>
                
                <FontAwesomeIcon style={{ margin: "0 5px" }} icon={faTimes} />
                Cancel
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </Fragment>);

};

const CreateCounselor = ({
  setOpenCreateCounselor,
  modify,
  school_id,
  getPageData,
  school_name
}) => {
  const timeoutRef = useRef();
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [email, setEmail] = useState();
  const [recoveryEmail, setRecoveryEmail] = useState();
  const [mobile, setMobile] = useState();
  const [promote, setPromote] = useState();
  const [password, setPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();

  const [showPasswordError, setShowPasswordError] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const [schoolName, setSchoolName] = useState();
  const [showSchoolNameContainer, setShowSchoolNameContainer] = useState(false);
  const [schoolNameList, setSchoolNameList] = useState();
  const schoolNameRef = useRef();
  const [schoolNameLoading, setSchoolNameLoading] = useState(false);
  const [selectedSchool, setSelectedSchool] = useState([]);
  const [districtId, setDistrictId] = useState(null);

  const extractSchools = (data) => {
    const payload = data?.data;
    if (Array.isArray(payload?.school)) return payload.school;
    if (Array.isArray(payload)) return payload;
    return [];
  };

  const getDistrictIdFromSchool = (school) =>
    school?.district_id ?? school?.district ?? school?.district?.id ?? null;

  const resolveDistrictId = () => {
    const fromSelected = (selectedSchool || [])
      .map(getDistrictIdFromSchool)
      .find(Boolean);
    if (fromSelected) return Promise.resolve(fromSelected);
    if (districtId) return Promise.resolve(districtId);

    const first = selectedSchool?.[0];
    if (!first?.name && !first?.id) return Promise.resolve(null);

    return GetAdminService.getSchoolsList(first.name || "")
      .then((data) => {
        const list = extractSchools(data);
        const match =
          list.find((item) => String(item?.id) === String(first.id)) || list[0];
        return getDistrictIdFromSchool(match);
      })
      .catch(() => null);
  };

  const getSchoolsList = (value) => {
    setSchoolNameLoading(true);
    setShowSchoolNameContainer(true);
    resolveDistrictId()
      .then((resolvedDistrictId) => {
        if (resolvedDistrictId && resolvedDistrictId !== districtId) {
          setDistrictId(resolvedDistrictId);
        }
        return GetAdminService.getSchoolsList(value, resolvedDistrictId);
      })
      .then((data) => {
        setSchoolNameList(extractSchools(data));
        setSchoolNameLoading(false);
      })
      .catch((_error) => {
        setSchoolNameLoading(false);
      });
  };


  const modifyData = () => {
    setFirstName(modify?.counselor?.first_name || "");
    setLastName(modify?.counselor?.last_name || "");
    setEmail(modify?.counselor?.email || "");
    setRecoveryEmail(modify?.counselor?.recovery_email || "");
    setMobile(modify?.counselor?.mobile || "");
    setPromote(modify?.counselor?.is_super_counselor);
    let arr = [];
    arr.push(modify["school"]);
    setSelectedSchool(arr[0]);
  };

  const setNull = () => {
    setSelectedSchool([]);
    setFirstName("");
    setLastName("");
    setEmail("");
    setMobile("");
    setPassword("");
    setConfirmPassword("");
  };

  const passwordValidation = (_value) => {
    if (password.length < 8) {
      setShowPasswordError("Password must be greater than 8 characters");
    } else if (password.length >= 8) {
      setShowPasswordError(false);
    }
  };

  const confirmPasswordValidation = (value) => {
    if (value !== password)
    setShowPasswordError("Password and Confirm Password should be same.");else
    setShowPasswordError(false);
  };

  const handleSchoolName = () => {
    clearTimeout(timeoutRef.current);
    setSchoolName(schoolNameRef.current.value);
    if (!schoolNameRef.current.value) {
      setShowSchoolNameContainer(false);
      setSchoolNameList([]);
    } else {
      timeoutRef.current = setTimeout(() => {
        getSchoolsList(schoolNameRef.current.value);
      }, 1000);
    }
  };

  const handleSelectedSchoolName = (item) => {
    setSelectedSchool([...selectedSchool, item]);
    const nextDistrict = getDistrictIdFromSchool(item);
    if (nextDistrict) setDistrictId(nextDistrict);
    setSchoolNameList([]);
    setSchoolName("");
    setShowSchoolNameContainer(false);
  };

  const removeSchoolName = (value) => {
    let filteredValue = selectedSchool?.filter((item) => item !== value);
    setSelectedSchool(filteredValue);
    const remainingDistrict = (filteredValue || [])
      .map(getDistrictIdFromSchool)
      .find(Boolean);
    setDistrictId(remainingDistrict || null);
  };

  const saveButtonHandler = () => {
    let arr = selectedSchool.map((item) => item.id);
    let obj = {
      first_name: firstName,
      last_name: lastName,
      email: email,
      recovery_email: recoveryEmail,
      mobile: mobile,
      is_super_counselor: promote,
      type: "counselor",
      schools: arr,
      user_id: modify?.counselor?.id
    };
    obj.password = password;
    obj.password_confirm = confirmPassword;
    if (modify) {
      GetAdminService.updateCounselor(obj)
      .then((_data) => {
        setNull();
        getPageData(school_id);
        setOpenCreateCounselor(false);
      })
      .catch((error) => {
        swal({
          text: error?.response?.data?.message,
          icon: "warning",
          dangerMode: true,
          buttons: {
            cancel: true,
            confirm: true
          },
          closeOnClickOutside: true
        }).then((_value) => {
        });
      });
    } else {
      GetAdminService.saveCounselor(obj)
      .then((data) => {
        setNull();
        getPageData(school_id);
        setOpenCreateCounselor(false);
        swal({
          text: data?.data?.message,
          icon: "success",
          buttons: {
            OK: true
          },
          closeOnClickOutside: true
        });
      })
      .catch((error) => {
        swal({
          text: error?.response?.data?.message,
          icon: "warning",
          dangerMode: true,
          buttons: {
            cancel: true,
            confirm: true
          },
          closeOnClickOutside: true
        }).then((_value) => {
        });
      });
    }
  };

  const deleteCounslor = () => {
    GetAdminService.deleteCounslor(modify?.counselor?.id)
    .then((_data) => {
      swal({
        text: "Counselor deleted successfully!",
        icon: "success",
        buttons: {
          confirm: true
        },
        closeOnClickOutside: false
      });
      setNull();
      getPageData(school_id);
      setOpenCreateCounselor(false);
    })
    .catch((_error) => {
    });
    setOpenDeleteModal(false);
  };

  useEffect(() => {
    if (modify) {
      modifyData();
    } else {
      setSelectedSchool([{ name: school_name, id: school_id }]);
    }
  }, []);

  useEffect(() => {
    const fromSelected = (selectedSchool || [])
      .map(getDistrictIdFromSchool)
      .find(Boolean);
    if (fromSelected) {
      setDistrictId(fromSelected);
      return;
    }
    const first = selectedSchool?.[0];
    if (!first?.name) return;
    GetAdminService.getSchoolsList(first.name)
      .then((data) => {
        const list = extractSchools(data);
        const match =
          list.find((item) => String(item?.id) === String(first.id)) || list[0];
        const resolved = getDistrictIdFromSchool(match);
        if (resolved) setDistrictId(resolved);
      })
      .catch(() => {});
  }, [selectedSchool]);

  return (
    <Fragment>
      <div className="create-student-container">
        <div className="drawer-header">
          <h3 className="drawer-title">
            {modify ? "Modify Counselor" : "New Counselor"}
          </h3>
          <button
            type="button"
            className="drawer-close-btn"
            onClick={() => {
              setOpenCreateCounselor(false);
              setNull();
            }}
            aria-label="Close">
            
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <div className="drawer-section">
          <div className="drawer-form-row">
            <div className="form-label-col">
              Add School
              <span className="required-marker">*</span>
            </div>
            <div className="form-field-col" style={{ position: "relative" }}>
              <input
                type="text"
                ref={schoolNameRef}
                placeholder="Type the school name"
                value={schoolName}
                onChange={handleSchoolName}
                autoComplete="off" />
              
              {showSchoolNameContainer &&
              <ul className="drawer-autocomplete">
                  {schoolNameLoading && <CustomLoader />}
                  {schoolNameList?.length > 0 &&
                schoolNameList.map((item, index) =>
                <li
                  onClick={() => handleSelectedSchoolName(item)}
                  key={index}>
                  
                        {item.name}
                      </li>
                )}
                </ul>}
              
            </div>
          </div>

          {selectedSchool?.length > 0 &&
          <div className="drawer-chip-list drawer-chip-list-scroll">
              {selectedSchool.map((item, index) =>
            <div key={item?.id || index} className="drawer-chip">
                  <span>{item?.name}</span>
                  <FontAwesomeIcon
                icon={faTimes}
                className="chip-remove"
                title="Remove school"
                onClick={() => removeSchoolName(item)} />
              
                </div>
            )}
            </div>}
          
        </div>

        <div className="drawer-section">
          <p className="drawer-section-label">Personal information</p>
          <div className="drawer-form-row">
            <div className="form-label-col">
              First Name
              <span className="required-marker">*</span>
            </div>
            <div className="form-field-col">
              <input
                type="text"
                placeholder="First Name"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)} />
              
            </div>
          </div>
          <div className="drawer-form-row">
            <div className="form-label-col">
              Last Name
              <span className="required-marker">*</span>
            </div>
            <div className="form-field-col">
              <input
                type="text"
                placeholder="Last Name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)} />
              
            </div>
          </div>
        </div>

        <div className="drawer-section">
          <p className="drawer-section-label">Contact</p>
          <div className="drawer-form-row">
            <div className="form-label-col">
              Email
              <span className="required-marker">*</span>
            </div>
            <div className="form-field-col">
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value.toLowerCase())} />
              
            </div>
          </div>

          <div className="drawer-form-row">
            <div className="form-label-col">Secondary Email</div>
            <div className="form-field-col">
              <input
                type="email"
                placeholder="Secondary Email"
                value={recoveryEmail}
                onChange={(e) => setRecoveryEmail(e.target.value.toLowerCase())} />
              
              <p className="help-text">
                Used in case account needs to be recovered
              </p>
            </div>
          </div>

          <div className="drawer-form-row">
            <div className="form-label-col">Mobile</div>
            <div className="form-field-col">
              <input
                type="text"
                placeholder="+19999999999"
                onChange={(e) => setMobile(e.target.value)}
                value={mobile} />
              
              <p className="help-text">Hint: +13238511115</p>
            </div>
          </div>
        </div>

        <div className="drawer-section">
          <p className="drawer-section-label">User information</p>
          <div className="drawer-form-row">
            <div className="form-label-col">
              Password
              <span className="required-marker">*</span>
            </div>
            <div className="form-field-col">
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onBlur={() => passwordValidation(password)} />
              
            </div>
          </div>
          <div className="drawer-form-row">
            <div className="form-label-col">
              Confirm Password
              <span className="required-marker">*</span>
            </div>
            <div className="form-field-col">
              <input
                type="password"
                placeholder="Confirm Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                onBlur={() => confirmPasswordValidation(confirmPassword)} />
              
            </div>
          </div>

          <label className="drawer-checkbox-row">
            <input
              type="checkbox"
              value={promote}
              onChange={() => setPromote(!promote)}
              checked={promote} />
            
            <span>Please check the box to promote as School Admin.</span>
          </label>

          {showPasswordError &&
          <p className="drawer-password-error">{showPasswordError}</p>}
          
        </div>

        <div className="drawer-footer">
          {modify &&
          <button
            type="button"
            className="drawer-btn-delete"
            onClick={() => setOpenDeleteModal(true)}>
            
              <FontAwesomeIcon icon={faTrash} />
              Delete
            </button>}
          
          {!modify ?
          <button
            type="button"
            onClick={saveButtonHandler}
            disabled={
            !(
            email &&
            firstName &&
            lastName &&
            password &&
            confirmPassword &&
            !showPasswordError)}


            className="drawer-btn-save">
            
              <FontAwesomeIcon icon={faSave} />
              Save
            </button> :

          <button
            type="button"
            onClick={saveButtonHandler}
            className="drawer-btn-save">
            
              <FontAwesomeIcon icon={faSave} />
              Save
            </button>}
          
        </div>
      </div>
      {openDeleteModal &&
      <MessageModal
        setIsOpen={setOpenDeleteModal}
        isOpen={openDeleteModal}
        data={{
          function1: deleteCounslor,
          message: "Are you sure you want to delete?"
        }} />}

      
    </Fragment>);

};
export default CreateCounselor;